import { Header as Component } from './components/Header';
import Connector from './connector';

export const Header = () => <Connector component={Component} />;
